import { Outlet } from 'react-router-dom';
import Navigation from '../navigation';
import Aside from '../aside';

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <header className="bg-white sticky top-0 h-[4rem] z-50">
        <Navigation />
      </header>
      <div className="flex w-full">
        <aside className="flex items-start justify-start md:p-4 bg-gray-700 sticky left-0 h-[calc(100vh_-_4rem)] xxs:hidden md:block md:w-[18rem] overflow-y-auto">
          <Aside />
        </aside>
        <main className="w-full h-[calc(100vh_-_4rem)] md:w-[calc(100vw_-_18rem)] p-3 md:p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
      {/* <footer className="flex items-center justify-center h-10">
        <p className="text-sm text-center">
          Copyright &copy; {new Date().getFullYear()} CMO APP
        </p>
      </footer> */}
    </div>
  );
};

export default Layout;
